import React from 'react'
import { IconSeeker } from '@ui-seeker/core'
import { AppBulkEditAction, AppDialogCancel } from '@components'
import { batch, useComputed } from '@preact/signals-react'
import { formData, formErrors } from '@signals'
import { selectedMappingId } from 'Pages/Admin/AdminMapping/@signals'
import { useAdminMappingForm } from 'Pages/Admin/AdminMapping/EditDrawer/@hooks'


export default function AdminMappingDrawerFooter() {

	const method = useComputed(() => formData.value?.method)
	const { submitPayload, isFormSubmitting } = useAdminMappingForm(method.value)
	const isValid = useComputed(() => Object.values(formErrors.value).every(e => e))

	return <>
		<AppDialogCancel onClick={() => batch(() => {
			selectedMappingId.value = null
			formData.value = {}
		})}/>
		<AppBulkEditAction
			sx={{ minWidth: 103 }}
			startIcon={<IconSeeker icon="floppy-disk"/>}
			loading={!!isFormSubmitting}
			onClick={submitPayload}
			disabled={!isValid.value}
		>
			Save
		</AppBulkEditAction>
	</>
}
